<template>
  <v-app class="error-page-container">
    <v-container class="error-page">
      <v-row class="logo-wrapper mt-3 mb-3">
        <v-img src="@/assets/logo.png" class="mr-3" contain width="70" height="70"></v-img>
        <span class="logo-title">{{ $t('general.signal') }}<i>{{ $t('general.view') }}</i></span>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="9" class="pb-6">
          <div class="card">
            <span class="error-logo">404</span>
            <p class="error-text">
              {{ $t('errorPage.message1') }}
            </p>
            <p class="error-subtext">
              {{ $t('errorPage.message2') }}
            </p>
            <v-btn
              class="text-capitalize primary"
              dark
              x-large
              :color="config.light.primary"
              to="/"
            >
              {{ $t('errorPage.button') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  import config from '@/config';

  export default {
    name: 'Error',
    data() {
      return {
        config,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/_variables.scss';

  .error-page-container {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background-color: var(--v-primary-base) !important;

    .error-page {
      display: flex;
      flex-direction: column;
      align-items: center;

      .logo-wrapper {
        align-items: center;

        .logo-title {
          font-size: 32px;
          font-weight: 500;
          color: white;
        }
      }
      .card {
        padding: 0 25px;
        background-color: white;
        border-radius: 4px;
        height: 600px;

        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;

        @include media-breakpoint-up(md) {
          padding: 0 50px;
        }
        .error-logo {
          color: var(--v-primary-base);
          font-size: 110px;
          font-weight: 600;
          @include media-breakpoint-up(md) {
            font-size: 148px;
          }
        }
        .error-text {
          color: var(--v-primary-base);
          text-align: center;
          font-size: $h4-font-size;
          @include media-breakpoint-up(md) {
            font-size: $h3-font-size;
          }
        }
        .error-subtext {
          text-align: center;
          color: var(--v-greyTint-base);
          font-size: $h5-font-size;
          @include media-breakpoint-up(md) {
            font-size: $h4-font-size;
          }
        }
      }
    }
  }
</style>
